module.exports = __webpack_public_path__ + "static/media/Messages.c9122433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NavIcons/Messages.png
// module id = 588
// module chunks = 0